import { Delete } from "@mui/icons-material";
import Edit from "@mui/icons-material/Edit";
import { ReactElement } from "react";

import Table, { DeleteManyState } from "~frontend/components/Table";
import TagChip from "~frontend/components/TagChip";
import { ListTagsWithIntegrationsTag } from "~frontend/graphql/tags";

import { renderActions, renderIntegrations } from "./tagTableRenderers";

export default function TagTable({
  rows,
  page,
  onChangePage,
  rowsPerPage,
  onChangeRowsPerPage,
  totalCount,
  onClickEdit,
  onClickDelete,
  deleteManyState,
  onChangeDeleteManyState,
}: {
  rows: ListTagsWithIntegrationsTag[];
  page: number;
  onChangePage: (newPage: number) => void;
  rowsPerPage: number;
  onChangeRowsPerPage: (newRowsPerPage: number) => void;
  totalCount: number;
  onClickEdit: (id: string) => void;
  onClickDelete: (id: string) => void;
  deleteManyState: DeleteManyState;
  onChangeDeleteManyState: (newState: DeleteManyState) => void;
}): ReactElement {
  return (
    <Table
      columns={[
        {
          key: "name",
          title: "Tag Name",
          renderValue: tag => <TagChip label={tag.name} />,
        },
        {
          key: "integration",
          title: "Integration",
          renderValue: tag => renderIntegrations(tag),
          align: "left",
        },
        {
          key: "actions",
          title: "Tag Action",
          renderValue: tag => renderActions(tag),
          align: "left",
        },
      ]}
      rows={rows}
      totalCount={totalCount}
      rowsPerPage={rowsPerPage}
      onChangeRowsPerPage={onChangeRowsPerPage}
      page={page}
      onChangePage={onChangePage}
      rowActions={tag => [
        {
          id: "edit",
          icon: <Edit />,
          tooltipLabel: "Edit",
          onClick: () => onClickEdit(tag.id),
        },
        {
          id: "delete",
          icon: <Delete />,
          tooltipLabel: "Delete",
          confirm: {
            title: "Delete Tag",
            content: `Are you sure you want to delete the "${tag.name}" tag?`,
          },
          onClick: () => onClickDelete(tag.id),
        },
      ]}
      selectedRows={
        deleteManyState.selecting ? deleteManyState.selectedIds : null
      }
      onChangeSelectedRows={tagIds =>
        onChangeDeleteManyState({
          selecting: true,
          selectedIds: tagIds,
          deleting: false,
        })
      }
      selectDisabled={deleteManyState.selecting && deleteManyState.deleting}
    />
  );
}
